/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllCampaigns = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/campaign/all?clientId=${clientId}` : '/campaign/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignDetailsById = async (campaignId: number) => {
    const response = await http.get(`/campaign/${campaignId}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const addNewCampaign = async (data: any) => {
    const response = await http.post(`/campaign/add`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateNewCampaign = async (data: any) => {
    const response = await http.put(`/campaign/update`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const deleteCampaign = async (data: any) => {
    const response = await http.delete(`/campaign/delete`, { data: data });
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const changeStatusCampaign = async (data: any) => {
    const response = await http.post(`/campaign/active`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const copyCampaign = async (data: any) => {
    const response = await http.post(`/campaign/copy`, data); // Directly pass data without wrapping in 'data'
    return response;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportData = async (campaignId: any, fromDate?: any, toDate?: any) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if(fromDate && toDate) {
        const response = await http.get(`/campaign/Report/Download/${campaignId}?fromDate=${fromDate}&toDate=${toDate}`);
        return response;
    }
    const response = await http.get(`/campaign/Report/Download/${campaignId}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateCampaignTestMode = async (data: any) => {
    const response = await http.post(`/campaign/changetestmode`, data);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportCardCounts = async (campaignId: any, clientId: any, startDate: any, endDate: any, status: any) => {
    const response = await http.get(`/campaign/dashboard/cardcounts?clientId=${clientId}&campaignId=${campaignId}&fromDate=${startDate}&toDate=${endDate}&status=${status}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportDomainCount = async (campaignId: any, clientId: any, startDate: any, endDate: any, status: any) => {
    const response = await http.get(`/campaign/dashboard/domaincounts?clientId=${clientId}&campaignId=${campaignId}&fromDate=${startDate}&toDate=${endDate}&status=${status}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getCampaignReportDeviceCount = async (campaignId: any, clientId: any, startDate: any, endDate: any, status: any) => {
    const response = await http.get(`/campaign/dashboard/devicecounts?clientId=${clientId}&campaignId=${campaignId}&fromDate=${startDate}&toDate=${endDate}&status=${status}`);
    return response;
}